import apis from '../../service/apis/selectAddress'
export const selectAddress = {
  namespaced: true,
  state: {
    cityList: [],
    placeList: [],
    address: {}
  },
  mutations: {
    getCityList (state, payload) {
      state.cityList = payload.data
    },
    placeSuggestion (state, payload) {
      state.placeList = payload.data && payload.data.place_data
    },
    getMapAdress (state, payload) {
      state.address = payload.data && payload.data.address
    },
    resetVuexData (state, payload) {
      switch (payload) {
        case 'placeList':
          state.placeList = []
          break
        case 'address':
          state.address = {}
          break

        default:
          break
      }
    }
  },
  actions: {
    getCityList ({ commit }, params) {
      apis.getCityList(params).then(res => {
        commit('getCityList', res)
      })
    },
    placeSuggestion ({ commit }, params) {
      apis.placeSuggestion(params).then(res => {
        commit('placeSuggestion', res)
      })
    },
    getMapAdress ({ commit }, params) {
      apis.getMapAdress(params).then(res => {
        commit('getMapAdress', res)
      })
    },
    resetVuexData ({ commit }, params) {
      commit('resetVuexData', params)
    }
  }
}
export const fenceData = {
  namespaced: true,
  state: {
    Count: {
      'totalCount': 0,
      'residueCount': 0,
      'createCount': 0
    },
    createSuc: {},
    deleteSuc: {},
    fenceList: []
  },
  mutations: {
    getFenceCount (state, payload) {
      state.Count = payload.data
      state.createSuc = {}
      state.deleteSuc = {}
    },
    createFence (state, payload) {
      state.createSuc = { id: payload.data || '' }
    },
    deleteFence (state, payload) {
      // console.log('deleteFence====>payload', payload)
      if (payload.status === 0) {
        state.deleteSuc = { id: payload.fenceId || '' }
      }
    },
    getFenceList (state, payload) {
      let arr = []
      payload.data && payload.data.map((v, i) => {
        arr.push({
          ...v.couponFence,
          fenceJson: v.fenceJson || {}
        })
      })
      state.fenceList = arr
      state.createSuc = {}
      state.deleteSuc = {}
    }
  },
  actions: {
    getFenceCount ({ commit }, params) {
      apis.getFenceCount(params).then(res => {
        commit('getFenceCount', res)
      })
    },
    createFence ({ commit }, params) {
      apis.createFence(params).then(res => {
        commit('createFence', res)
      })
    },
    deleteFence ({ commit }, params) {
      apis.deleteFence(params).then(res => {
        commit('deleteFence', { ...params, ...res })
      })
    },
    getFenceList ({ commit }, params) {
      apis.getFenceList(params).then(res => {
        commit('getFenceList', res)
      })
    }
  }
}
